import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

/** Fires a `/traffic/hit` POST on every route change.
 *
 *   - Ignored for admin/employee/distributor/print routes to keep the traffic
 *     dashboard focused on real customer/audience visits.
 *   - A per-tab session id is stored in sessionStorage so we can count sessions
 *     without ever setting a cross-site cookie.
 */
const IGNORE_PREFIXES = ["/admin", "/employee", "/distributor", "/invoice/"];

function sessionId() {
    try {
        let s = sessionStorage.getItem("hpl_traffic_sid");
        if (!s) {
            s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
            sessionStorage.setItem("hpl_traffic_sid", s);
        }
        return s;
    } catch {
        return "no-storage";
    }
}

export default function TrafficPing() {
    const loc = useLocation();
    useEffect(() => {
        const path = loc.pathname + (loc.search || "");
        if (IGNORE_PREFIXES.some((p) => loc.pathname.startsWith(p))) return;
        const timeout = setTimeout(() => {
            api.post("/traffic/hit", {
                path,
                referrer: document.referrer || "",
                title: document.title || "",
                session_id: sessionId(),
            }).catch(() => { /* best-effort */ });
        }, 400); // debounce fast route toggles
        return () => clearTimeout(timeout);
    }, [loc.pathname, loc.search]);
    return null;
}
